import { AxiosRequestConfig } from "axios";

export enum EOrder {
  ASC = "ascend",
  DESC = "descend",
}

export enum EHttpStatusCode {
  OK = 200,
  CREATED = 201,
  NOT_MODIFIED = 304,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  REQUEST_TIMEOUT = 408,
  UNPROCESSABLE_ENTITY = 422,
  INTERNAL_SERVER_ERROR = 500,
  BAD_GATEWAY = 502,
  SERVICE_UNAVAILABLE = 503,
}

// ErrorCode trả về từ BE (POST /api/v1/auth/login, HTTP 400) — khớp CHÍNH XÁC
// swagger/AuthService (api-integration.md §2.1): PascalCase, không dấu cách.
export enum ELoginFailResCode {
  INVALID_USERNAME_FORMAT = "InvalidUsernameFormat",
  INVALID_PASSWORD_FORMAT = "InvalidPasswordFormat",
  NOT_EXIST_USER = "NotExistUser",
  WRONG_PASSWORD = "WrongPassword",
  DEACTIVE_USER = "DeactiveUser",
}

export enum EForgotPasswordResCode {
  NOT_FOUND = "NOT_FOUND",
  NOT_ACCEPTABLE = "NOT_ACCEPTABLE",
  FAILED = "failed",
}

export enum EResetPasswordResCode {
  CAN_NOT_RESET = 304,
}

export type TSearchRequest = {
  keyword: string;
  page: number;
  size: number;
  order?: string;
  direction?: EOrder;
};

export type TSearchResponse<I = any> = {
  items: I[];
  total: number;
  size: number;
  current: number;
  totalPage: number;
};

export type TImportRowError = {
  rowNumber: number;
  columns: {
    name: string;
    value: string;
    error: string;
  }[];
};

export type TAxiosError = {
  config: AxiosRequestConfig;
  data?: any;
  request?: any;
  headers?: any;
  status?: number;
};
